module.exports = __webpack_public_path__ + "static/lifestyleQuote-1ce3195a87de201d90204d0b95c497d4.png";